<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="群活码名称">
              <a-input
                placeholder="请输入群活码名称"
                v-model="queryParam.name"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-button type="primary" @click="searchQuery" icon="search"
            >查询</a-button
          >
          <a-button
            type="primary"
            @click="searchReset"
            icon="reload"
            style="margin-left: 8px"
            >重置</a-button
          >
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新增群活码</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <!--下拉栏显示的菜单， 通过slot="overlay"控制-->
        <a-menu slot="overlay">
          <!--  批量删除操作        -->
          <a-menu-item @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <!--下拉菜单的默认显示结束-->
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a
          style="font-weight: 600"
          >{{ selectedRowKeys.length }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <!--
        :pagination="ipagination" -->
      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        :rowKey="r => r.id"
        @change="handleTableChange"
      >
        <template slot="tags" slot-scope="text, record">
          <a-tag color="blue" v-for="item in record.tags" :key="item.id">
            {{ item.name }}
          </a-tag>
        </template>
        <!--        <template slot="ctype" slot-scope="text">-->
        <!--          {{ text == '0' ? '单人' : '多人' }}-->
        <!--        </template>-->
        <!--        <template slot="needVerify" slot-scope="text">-->
        <!--          {{ text == '1' ? '是' : '否' }}-->
        <!--        </template>-->
        <!--        <template slot="scene" slot-scope="text">-->
        <!--          {{ text == true ? '小程序' : '扫描二维码' }}-->
        <!--        </template>-->
        <!--        <template slot="avatarslot" slot-scope="text, record">-->
        <!--          <div class="anty-img-wrap">-->
        <!--            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" />-->
        <!--          </div>-->
        <!--        </template>-->
        <template slot="custNum" slot-scope="text, record">
          <a @click="openGroupChat(record)">{{ text }}</a>
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)" v-has="'user:edit'">编辑</a>-->
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <!-- <a download="qrCode.png" :href="record.qrCode" >下载二维码</a> -->
          <!-- <a v-if="record.isDisabled==0&&record.validTime==='长期有效'" :href="imgUrl+'wechatwork-groupchat-biz/wechatwork/groupBarcode/downloadGroupBarcode?id='+record.id" @click="downLoadCode(record.id)">下载二维码</a> -->
          <!-- <a v-if="record.isDisabled==0&&record.validTime==='长期有效'" @click="downLoadCode(record.url)">下载二维码</a> -->
          <a @click="downLoadCode(record.url)">查看二维码</a>
          <!-- <a v-else href="javascript:return false;" style="opacity: 0.3">下载二维码</a> -->

          <!-- <a-divider type="vertical" />
          <a @click="JumpChatInfoview(record)">查看客户</a> -->

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <a-drawer
        title="关联群聊"
        placement="right"
        :closable="false"
        :visible="visibleGroupChat"
        @close="onCloseGroupChat"
        width="500"
      >
        <a-table
          :columns="columnsGroupChat"
          :data-source="dataGroupChat"
        ></a-table>
      </a-drawer>
    </div>
    <!-- table区域-end -->

    <group-barcode-modal
      ref="modalForm"
      @ok="modalFormOk"
      @searchReset="searchReset"
    ></group-barcode-modal>

    <a-modal
      title="查看二维码"
      :visible="visibleCode"
      @ok="visibleCode = false"
      @cancel="visibleCode = false"
    >
      <img :src="qrPng" alt="" />
      <!-- <a-input-search placeholder="请输入使用人员姓名" style="width: 200px;margin-bottom: 20px;"
        allowClear @search="onSearch" />
        <a-table :columns="columnsModal" :data-source="customerList" :pagination=false>
          <span slot="action" slot-scope="text, record">
            <a href="javascript:viod(0)" @click="toJump(record.userId)">查看客户</a>
          </span>
        </a-table> -->
    </a-modal>

    <!-- :confirm-loading="confirmLoading" -->
    <!-- <a-modal
      title="查看客户"
      :visible="visible"
      @ok="visible = false"
      @cancel="visible = false"
    >
      <a-input-search placeholder="请输入使用人员姓名" style="width: 200px;margin-bottom: 20px;"
        allowClear @search="onSearch" />
        <a-table :columns="columnsModal" :data-source="customerList" :pagination=false>
          <span slot="action" slot-scope="text, record">
            <a href="javascript:viod(0)" @click="toJump(record.userId)">查看客户</a>
          </span>
        </a-table>
    </a-modal> -->
  </a-card>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
// import JSelectPosition from '@/components/jeecgbiz/JSelectPosition'
// import departWindow from '../../system/modules/DepartWindow'
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction, getFileAccessHttpUrl } from '@/api/manage';
import { addMember, editUser, queryUserRole, queryall } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';

import groupBarcodeModal from './groupBarcodeModal';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

export default {
  name: 'groupBarcodeManagement',
  mixins: [JeecgListMixin],
  components: {
    groupBarcodeModal
  },
  data() {
    return {
      qrPng: '',
      visibleCode: false,
      imgUrl: process.env.VUE_APP_GATEWAY_URL,
      visibleGroupChat: false,
      description: '这是企业微信群活码页面',
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        {
          title: '群活码名称',
          align: 'center',
          dataIndex: 'name',
          customRender: function(text, record, index) {
            if (text == null) {
              return '-';
            } else {
              return text.length > 20 ? text.substr(0, 20) + '...' : text;
            }
          }
        },
        {
          title: '关联群聊',
          align: 'center',
          dataIndex: 'groupNum',
          // customRender :function(text) {
          //     if (text !== null && text !== '') {
          //         return text;
          //     } else {
          //         return "-";
          //     }
          // },
          scopedSlots: {
            customRender: 'custNum'
          }
        },
        {
          title: '群人数限制',
          align: 'center',
          dataIndex: 'ultimate'
        },
        // {
        //   title: '维护人员',
        //   align: 'center',
        //   dataIndex: 'repairUserName',
        //   customRender :function(text) {
        //       if (text !== null && text !=="") {
        //           return text;
        //       } else {
        //           return "--";
        //       }
        //   }
        // },
        {
          title: '标签',
          align: 'left',
          dataIndex: 'tagNames',
          ellipsis: true,
          // customRender :function(text,record) {
          //   if (text !== null && text !=="") {
          //       return text
          //   } else {
          //     return  '-'
          //   }
          // },
          scopedSlots: {
            customRender: 'tags'
          }
        },

        {
          title: '有效期限',
          align: 'center',
          dataIndex: 'validTime'
        },
        {
          title: '群活码状态',
          align: 'center',
          dataIndex: 'isDisabled',
          customRender: function(text) {
            if (text == 0) {
              return '开启状态';
            } else if (text == 1) {
              return '禁用状态';
            }
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center'
        }
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/queryGroupBarcodeList',
        // list: 'wechatwork/groupBarcode/queryGroupBarcodeList',
        delete:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/deleteGroupBarcode',
        queryGroupChatById:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/queryGroupChatById',
        downloadGroupBarcode:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/downloadGroupBarcode',
        deleteBatch:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/groupBarcode/deleteBatchGroupBarcode'
      },
      title: '操作',
      visible: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      recordRow: {},
      columnsGroupChat: [
        { title: '群名称', dataIndex: 'groupChatName', align: 'center' },
        { title: '群成员数', dataIndex: 'memberNum', align: 'center' },
        { title: '群主', dataIndex: 'owner', align: 'center' }
      ],
      dataGroupChat: [],
      tagsList: []
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  watch: {},
  methods: {
    handleTags(value) {
      let arr = (this.tagsList = value.split(','));

      return arr;
    },
    downLoadCode(url) {
      // getAction(this.url.downloadGroupBarcode, {
      //   id: id
      // }).then(res => {
      //   console.log(res, 555);
      // })
      this.visibleCode = true;
      this.qrPng = process.env.VUE_APP_CMS_MINIOURL + url;
    },
    openGroupChat(record) {
      // console.log(record);
      getAction(this.url.queryGroupChatById, {
        id: record.id,
        pageSize: 100000000 //为了获取全部群聊列表
      }).then(res => {
        this.dataGroupChat = res.result.list;
      });
      this.visibleGroupChat = true;
    },
    onCloseGroupChat() {
      this.visibleGroupChat = false;
    },
    // modalFormOk() {
    //   this.loadData();
    // },
    onSearch() {},
    onChange(date, dateString) {
      console.log(date, dateString);
      this.queryParam.ctime = dateString.join(' - ');
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar);
    },
    handleMenuClick(e) {
      console.log('点击批量删除按钮');
      if (e.key === '1') {
        console.log('批量删除');
        this.batchDel();
      }
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username);
    },
    JumpChatInfoview(record) {
      console.log(record);
      this.recordRow = record;
      this.visible = true;
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
